import { ChatsCircle, Coins, EyeSlash } from "@phosphor-icons/react";

export function Features() {
	return (
		<section className="py-12 px-4 bg-white">
			<div className="max-w-4xl mx-auto grid grid-cols-2 gap-4">
				{/* Chat & Calls — full width */}
				<div className="col-span-2 relative border-4 border-[#0F172A] rounded-[20px] overflow-hidden bg-[#FFF0EE]">
					{/* Text — safe zone, never overlapped */}
					<div className="px-7 pt-7 pb-6 relative z-10 md:w-[55%]">
						<div className="w-12 h-12 bg-[#FF6B4A] text-white rounded-2xl flex items-center justify-center mb-5">
							<ChatsCircle size={24} weight="fill" />
						</div>
						<h3 className="font-extrabold text-[22px] md:text-2xl text-[#0F172A] mb-2 leading-tight">
							Chat and call — without exchanging numbers
						</h3>
						<p className="text-[14px] md:text-[15px] text-[#475569] leading-relaxed max-w-sm">
							Negotiate, send photos, and hop on a call — all inside Proxi. Your
							phone number and WhatsApp stay yours.
						</p>
					</div>

					{/* Illustration — desktop: absolute right, full height */}
					<div
						className="hidden md:block absolute right-0 bottom-0 top-0 w-[48%] pointer-events-none"
						style={{
							maskImage: "linear-gradient(to right, transparent 0%, black 22%)",
						}}
					>
						<img
							src="/illustrations/chat-calls.png"
							alt=""
							aria-hidden="true"
							className="w-full h-full object-contain object-right-bottom"
							style={{ opacity: 0.82, mixBlendMode: "multiply" }}
						/>
					</div>

					{/* Illustration — mobile: strip below text, never overlaps */}
					<div
						className="md:hidden h-[130px] relative pointer-events-none"
						style={{
							maskImage:
								"linear-gradient(to bottom, transparent 0%, black 30%, black 70%, transparent 100%)",
						}}
					>
						<img
							src="/illustrations/chat-calls.png"
							alt=""
							aria-hidden="true"
							className="w-full h-full object-contain object-center"
							style={{ opacity: 0.78, mixBlendMode: "multiply" }}
						/>
					</div>
				</div>

				{/* Rewards */}
				<div className="col-span-1 relative border-4 border-[#0F172A] rounded-[20px] overflow-hidden bg-[#FFFBE6]">
					{/* Content — fixed height safe zone */}
					<div className="px-5 pt-6 pb-3 relative z-10">
						<div className="w-11 h-11 bg-[#F59E0B] text-white rounded-xl flex items-center justify-center mb-4">
							<Coins size={20} weight="fill" />
						</div>
						<h3 className="font-extrabold text-lg text-[#0F172A] mb-1 leading-tight">
							Rewards
						</h3>
						<p className="text-[13px] text-[#475569] leading-relaxed">
							Earn points on every errand. Redeem as wallet cashback.
						</p>
					</div>
					{/* Illustration strip — below content, not overlapping */}
					<div
						className="h-[110px] relative pointer-events-none"
						style={{
							maskImage:
								"linear-gradient(to bottom, transparent 0%, black 30%, black 80%, transparent 100%)",
						}}
					>
						<img
							src="/illustrations/rewards.png"
							alt=""
							aria-hidden="true"
							className="w-full h-full object-contain object-center"
							style={{ opacity: 0.78, mixBlendMode: "multiply" }}
						/>
					</div>
				</div>

				{/* Privacy */}
				<div className="col-span-1 relative border-4 border-[#0F172A] rounded-[20px] overflow-hidden bg-[#EDFCF5]">
					{/* Content — fixed height safe zone */}
					<div className="px-5 pt-6 pb-3 relative z-10">
						<div className="w-11 h-11 bg-[#00C49A] text-white rounded-xl flex items-center justify-center mb-4">
							<EyeSlash size={20} weight="fill" />
						</div>
						<h3 className="font-extrabold text-lg text-[#0F172A] mb-1 leading-tight">
							Private by default
						</h3>
						<p className="text-[13px] text-[#475569] leading-relaxed">
							Your phone number, WhatsApp, and personal details stay yours.
						</p>
					</div>
					{/* Illustration strip — below content, not overlapping */}
					<div
						className="h-[110px] relative pointer-events-none"
						style={{
							maskImage:
								"linear-gradient(to bottom, transparent 0%, black 30%, black 80%, transparent 100%)",
						}}
					>
						<img
							src="/illustrations/privacy.png"
							alt=""
							aria-hidden="true"
							className="w-full h-full object-contain object-center"
							style={{ opacity: 0.78, mixBlendMode: "multiply" }}
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
